import React, { useState, useEffect } from 'react'
import { useUser } from 'util/UserContext'
import { useNavigate } from 'react-router-dom'
import UsernameModal from 'components/User/UsernameModal'
import UserAvatarModal from 'components/User/UserAvatarModal'
import UserAboutBriefModal from 'components/User/UserAboutBriefModal'
import UserAboutIssueModal from 'components/User/UserAboutIssueModal'
import UserDisplaynameModal from 'components/User/UserDisplaynameModal'
import UserAboutLinksModal from 'components/User/UserAboutLinksModal'
import UserAlignmentModal from 'components/User/UserAlignmentModal'
import UserAboutBackgroundModal from 'components/User/UserAboutBackgroundModal'
import ProfileSettingsButton from 'ui/ProfileSettingsButton'

const UserSettingsProfile: React.FC = () => {
    const { currentUser, awaitingUser } = useUser()
    const navigate = useNavigate()
    const [showUsernameModal, setShowUsernameModal] = useState<boolean>(false)
    const [showDisplaynameModal, setShowDisplaynameModal] = useState<boolean>(false)
    const [showAvatarModal, setShowAvatarModal] = useState<boolean>(false)
    const [showBriefModal, setShowBriefModal] = useState<boolean>(false)
    const [showLinksModal, setShowLinksModal] = useState<boolean>(false)
    const [showIssueModal, setShowIssueModal] = useState<boolean>(false)
    const [showAlignmentModal, setShowAlignmentModal] = useState<boolean>(false)
    const [showBackgroundModal, setShowBackgroundModal] = useState<boolean>(false)

    useEffect(() => {
        if (!awaitingUser && !currentUser) {
            navigate('/login', { replace: true })
        }
    }, [currentUser, awaitingUser, navigate])


    return (
        <div className="p-2">
                {/* General Section */}
                <div className="form-control space-y-2">
                    <label className="form-label text-base">General</label>
                    <ProfileSettingsButton
                        title="Username"
                        description="Change your username."
                        onClick={() => setShowUsernameModal(true)}
                    />
                    <ProfileSettingsButton
                        title="Name"
                        description="Set your name; this is usually what people call you."
                        onClick={() => setShowDisplaynameModal(true)}
                    />
                    <ProfileSettingsButton
                        title="Avatar"
                        description="Add or change your profile avatar."
                        onClick={() => setShowAvatarModal(true)}
                    />
                </div>

                {/* About Section */}
                <div className="form-control space-y-2">
                    <label className="form-label text-base">About</label>
                    <ProfileSettingsButton
                        title="Brief"
                        description="Add a short bio to your profile."
                        onClick={() => setShowBriefModal(true)}
                    />
                    <ProfileSettingsButton
                        title="Background"
                        description="Share information that shapes your perspective."
                        onClick={() => setShowBackgroundModal(true)}
                    />
                    <ProfileSettingsButton
                        title="#1 Issue"
                        description="Share what matters most to you."
                        onClick={() => setShowIssueModal(true)}
                    />
                    <ProfileSettingsButton
                        title="Perspective"
                        description="Define your social and political views."
                        onClick={() => setShowAlignmentModal(true)}
                    />
                    <ProfileSettingsButton
                        title="Links"
                        description="Add social media and other links."
                        onClick={() => setShowLinksModal(true)}
                        settingValue={currentUser?.properties?.about_bio_links?.value?.length || 0}
                    />
                </div>

                {/* Modals */}
                {showUsernameModal && (
                    <UsernameModal onClose={() => setShowUsernameModal(false)} />
                )}

                {showDisplaynameModal && (
                    <UserDisplaynameModal onClose={() => setShowDisplaynameModal(false)} />
                )}

                {showAvatarModal && (
                    <UserAvatarModal onClose={() => setShowAvatarModal(false)} />
                )}

                {showBriefModal && (
                    <UserAboutBriefModal onClose={() => setShowBriefModal(false)} />
                )}

                {showLinksModal && (
                    <UserAboutLinksModal onClose={() => setShowLinksModal(false)} />
                )}

                {showIssueModal && (
                    <UserAboutIssueModal onClose={() => setShowIssueModal(false)} primaryIssue={currentUser?.properties?.about_bio_issue?.value} />
                )}

                {showAlignmentModal && (
                    <UserAlignmentModal onClose={() => setShowAlignmentModal(false)} />
                )}

                {showBackgroundModal && (
                    <UserAboutBackgroundModal isOpen={showBackgroundModal} onClose={() => setShowBackgroundModal(false)} initialData={currentUser?.properties} privacy={currentUser?.properties?.privacy_content_default_audience?.value || 'public'}/>
                )}
        </div>
    )
}

export default UserSettingsProfile